import Icon from '@ant-design/icons';
import { Flex, Grid, Tooltip } from 'antd';
import { useSetAtom } from 'jotai';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import QuestionMarkIcon from '~/assets/svg/icon-question-mark.svg?react';
import { headerTitleAtom } from '~/atoms';
import { SEARCH_PARAMETERS_API_IDS, STATUS_API_IDS } from '~/helpers/conversation';
import { HELP_MESSAGERIE_LINK } from '~/helpers/general';

import ConversationMobileDrawer from './ConversationPanel/ConversationMobileDrawer';
import ConversationPanel from './ConversationPanel/ConversationPanel';
import './Conversations.scss';
import ConversationsSidebar from './ConversationsSidebar/ConversationsSidebar';

function retrieveParamsFromURL(params) {
  if (params === '') return {};

  const paramsObject = {};
  const URLGetParams = new URLSearchParams(params);
  Object.keys(SEARCH_PARAMETERS_API_IDS).forEach((key) => {
    const paramKey = SEARCH_PARAMETERS_API_IDS[key];
    const value = URLGetParams.get(paramKey);
    if (value) {
      if (value.includes(',')) {
        paramsObject[paramKey] = value.split(',');
      } else {
        paramsObject[paramKey] = value;
      }
    }
  });
  return paramsObject;
}

export function paramsToURL(params, exclude = []) {
  const URLGetParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key] === '' || key in exclude) return;
    URLGetParams.append(key, params[key]);
  });
  return '?' + URLGetParams.toString();
}

function Conversations({ history, activeMerchantId }) {
  const params = retrieveParamsFromURL(location.search);
  const currentStatus = params[SEARCH_PARAMETERS_API_IDS.STATUS];
  const isOpenTab = currentStatus === STATUS_API_IDS.OPEN || !currentStatus;
  const [selectedConversation, setSelectedConversation] = useState(null);
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.lg;
  const setHeaderTitle = useSetAtom(headerTitleAtom);

  useEffect(() => {
    if (isMobile) setHeaderTitle('Messagerie');
    return () => setHeaderTitle('');
  }, [isMobile]);

  const changeParams = (newParams) => {
    setSelectedConversation(null);
    history.push({
      pathname: location.pathname,
      search: paramsToURL(newParams),
    });
  };

  const navigateToConversationStatus = useCallback(
    (status) => {
      const newTabStatus = status.startsWith('closed') ? [STATUS_API_IDS.CLOSED_BY_MERCHANT, STATUS_API_IDS.CLOSED_AUTO] : STATUS_API_IDS.OPEN;
      history.replace({
        pathname: location.pathname,
        search: paramsToURL({ [SEARCH_PARAMETERS_API_IDS.STATUS]: newTabStatus }),
      });
    },
    [history]
  );

  return (
    <Flex vertical className={`conversations-layout ${isOpenTab ? 'status-open' : 'status-closed'}`}>
      {!isMobile && (
        <Flex className='px-l py-m shrink-0' gap={8} align='center'>
          <p className='sub1'>Messagerie</p>
          <Tooltip title='Lien vers la formation' placement='bottom'>
            <a target='_blank' rel='noopener noreferrer' href={HELP_MESSAGERIE_LINK} className='text-grey'>
              <Icon className='text-[30px]' component={QuestionMarkIcon} />
            </a>
          </Tooltip>
        </Flex>
      )}
      <div className='flex flex-1 overflow-hidden'>
        <div className='conversations-sidebar'>
          <ConversationsSidebar
            params={params}
            changeParams={changeParams}
            selectedConversation={selectedConversation}
            setSelectedConversation={setSelectedConversation}
            activeMerchantId={activeMerchantId}
            navigateToConversationStatus={navigateToConversationStatus}
          />
        </div>
        {isMobile ? (
          <ConversationMobileDrawer
            selectedConversation={selectedConversation}
            setSelectedConversation={setSelectedConversation}
            activeMerchantId={activeMerchantId}
            onStatusChange={navigateToConversationStatus}
          />
        ) : (
          <div className='conversations-panel'>
            <ConversationPanel
              selectedConversation={selectedConversation}
              setSelectedConversation={setSelectedConversation}
              params={params}
              activeMerchantId={activeMerchantId}
              onStatusChange={navigateToConversationStatus}
            />
          </div>
        )}
      </div>
    </Flex>
  );
}

export default connect(({ session }) => ({ activeMerchantId: session.active_merchant.id }))(Conversations);
